import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { saveAs } from 'file-saver';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import useParamsHeadCount from '../../helpers/useParamsHeadCount';
import { LabelField } from './Employes.styles';
import dateFormat from '../../services/DateFormat.service';
import '../../DataTableDemo.css';
import { useHistory } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';
import "../../utils/tooltip.css"
import Video from '../Video/Video';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import { Skeleton } from 'primereact/skeleton';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Employes.css'
import { Tag } from 'primereact/tag';
import { DataView } from 'primereact/dataview';
import { SelectButton } from 'primereact/selectbutton';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Employes
Description : Pagina de Appointment para el CRUD de los empleados del aplicativo remunerlite.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina - Pagina de Empleados
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Employes() {

  // declarar constantes
  const [headCountParams] = useParamsHeadCount();
  const [headCount, setHeadCount] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false)
  const [loading3, setLoading3] = useState(false)
  const [loading4, setLoading4] = useState(false)
  const [loading5, setLoading5] = useState(false)
  const [consultado, setConsultado] = useState(false);
  const [consultado2, setConsultado2] = useState(false);
  const [isOpenHC, setIsOpenHC] = React.useState(false);
  const [isOpenS, setIsOpenS] = React.useState(false);
  const [isOpenE, setIsOpenE] = React.useState(false);
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const headers = { authorization: localStorage.getItem('token') }
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const [loadPage, setLoadPage] = useState(false)

  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  let history = useHistory();

  const [tipo, setTipo] = useState(localStorage.getItem('vista'))

  const options = [
    { icon: 'pi pi-table', value: 'tabla' },
    { icon: 'pi pi-th-large', value: 'tarjeta' }
  ];

  const template = (option) => {
    return <i className={option.icon}></i>;
  }

  // funcion para obtener los empleados
  useEffect(() => {
    localStorage.removeItem('number_id')
    localStorage.removeItem('name')
    setTabla()
  }, []);

  useEffect(() => {
    /*Se inicializan las propiedades del reporte head count*/
    const HCTemplate = async () => {
      let plantilla3 = []
      headCountParams.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla3.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla3.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setHeadCount(plantilla3)
    }
    HCTemplate()
  }, [headCountParams]);

  async function setTabla() {
    let contenidoTabla = []
    // await apis.getBusiness(headers).then(res => {
    //   localStorage.setItem('client', res.data.COMPANY[0]["CLIENT"]);
    // })
    await apis.getContracts_client(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('token'), headers).then(res => {
      let data = res.data.CONTRACTS;
      data.forEach(element => {
        let status = element["STATUS"].split("|")
        let contractType = element["CONTRACT_TYPE"].split("|")
        let retirement = element["CAUSE_RETIREMENT"].split("|")
        let job = element["JOB_ID"].split("|")
        let fechaInicio = tableDate(element.START_DATE)
        let fechaFin = tableDate(element.END_DATE)
        let fechaRetiro = tableDate(element.RETIREMENT_DATE)
        contenidoTabla.push({
          CONTRACT_ID: element.CONTRACT_ID, NAME: element.NAME, CONTRACT_TYPE_ID: contractType[0], IMAGE: element.IMAGES,
          CONTRACT_TYPE: contractType[1], JOB_ID: job[0], JOB: job[1], NUMBER_ID: element.NUMBER_ID, STATUS_ID: status[0],
          STATUS: status[1], START_DATE: fechaInicio, END_DATE: fechaFin, RETIREMENT_DATE: fechaRetiro,
          CAUSE_RETIREMENT_ID: retirement[0], CAUSE_RETIREMENT: retirement[1]
        })
      })
      console.log(contenidoTabla)
      setProducts(contenidoTabla)
      setLoadPage(true)
    })
  }

  //función para enviar a la pagina CreatePerson agregando o editando elementos number_id,contract_id del local storage
  function editPerson(person) {
    localStorage.setItem('number_id', person.NUMBER_ID);
    localStorage.setItem('contract_id', person.CONTRACT_ID);
    localStorage.setItem('image', person.IMAGE)
    localStorage.setItem('name', person.NAME)
    history.push("/CreatePerson")
    // window.location.href = "./CreatePerson"
  }

  //Función para enviar a la pagina CreatePerson y eliminar elementos number_id,contract_id del local storage
  function createPerson() {
    localStorage.removeItem('number_id');
    localStorage.removeItem('contract_id');
    localStorage.removeItem('image')
    history.push("/CreatePerson")
    // window.location.href = "./CreatePerson"
  }


  //Función para redirecionar a la pagina Social_benefits
  function liquidar() {
    history.push("/Novelties")
  }

  const showModalHC = () => {
    setIsOpenHC(true);
  };

  const hideModalHC = () => {
    setIsOpenHC(false);
  };

  const showModalS = () => {
    setIsOpenS(true);
  };

  const hideModalS = () => {
    setIsOpenS(false);
  };

  const showModalE = () => {
    setIsOpenE(true);
  };

  const hideModalE = () => {
    setIsOpenE(false);
  };

  const gridItem = (product) => {
    return (
      <div className="col-13 sm:col-6 lg:col-12 xl:col-4 p-2" key={product.CONTRACT_ID}>
        <div className="p-4 border-1 surface-border surface-card border-round">
          <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <div className="flex align-items-center gap-2">
              <i className="pi pi-briefcase"></i>
              <span className="font-semibold">{product.JOB} - {product.CONTRACT_TYPE}</span>
            </div>
            <div className="flex flex-row align-items-center">
              <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-xs text-xs" size='small' onClick={() => editPerson(product)} />
              <Tag value={product.STATUS} severity={product.STATUS === 'ACTIVO' ? 'success' : 'danger'}></Tag>
            </div>
          </div>
          <div className="flex flex-row align-items-start gap-3 py-5">
            <div style={{ width: '150px', height: '150px' }}>
              <img className="w-9 shadow-2 border-round" src={product.IMAGE ? product.IMAGE : process.env.REACT_APP_PROFILE_PIC} alt={product.NAME} />
            </div>
            <div className="flex flex-column align-items-start text-left">
              <div className="text-md font-bold text-align-start">{product.NAME}</div>
              <span className="text-md">Contrato: {product.CONTRACT_ID} - CC: {product.NUMBER_ID}</span>
              <span className="text-md">Desde: {iniDateTemplate(product)} Hasta: {endDateTemplate(product)}</span>
              <span className="text-md">Retiro: {product.CAUSE_RETIREMENT} - {retDateTemplate(product)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const itemTemplate = (product) => {
    if (!product) {
      return;
    }
    return gridItem(product);
  };

  const listTemplate = (products) => {
    console.log(products)
    return <div className="grid grid-nogutter">{products.map((product, index) => itemTemplate(product))}</div>;
  };

  const footerHC = (
    <div>
      <Button label="Generar" loading={loading} onClick={() => { setLoading(true); postHeadCountReport() }} />
    </div>
  );

  const headerHC = (
    <div>
      <h3>Parámetros reporte head count</h3>
    </div>
  )

  function handleChangeHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeDateHC(e, d, index) {
    let date = dateFormat(e.value)
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeTextHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }
  async function postHeadCountReport() {
    /*Función encargada de cargar la informacion del reporte head count*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    headCount.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    headCount.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.postReportHeadCount(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteHeadCount")
        setLoading(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte head count generado existosamente" });
        hideModalHC();
      })
    }
    catch (err) {
      setLoading(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function downloadSampleFile() {
    let payload = {
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.importSalary(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading2(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading2(false)
    }
  }

  async function downloadSampleFileEmployees() {
    let payload = {
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.importEmployees(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading4(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading4(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.importSalary(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importDataContracts(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.importEmployees(_importedData, headers).then(res => {
        setConsultado2(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado2(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importSalaries(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0]

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  async function importContracts(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado2(true);
    showConfirm();
    const file = e.files[0]

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importDataContracts(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm "
          tooltip='Crear empleado nuevo' onClick={() => createPerson()} tooltipOptions={{ position: 'top' }} />
        <Button label="Cargue Histórico de Salarios" icon="pi pi-dollar" className="p-button-success mr-2 p-button-sm "
          tooltip='Proceso cargue masivo salarios' tooltipOptions={{ position: 'top' }}
          onClick={() => showModalS()}
        />
        <Button label="Cargar empleados" icon="pi pi-users" className="p-button-success mr-2 p-button-sm "
          tooltip='Proceso cargue masivo empleados' tooltipOptions={{ position: 'top' }}
          onClick={() => showModalE()}
        />
      </React.Fragment>
    )
  }

  //Boton liquidar Nómina en la parte derecha de la tabla
  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Liquidar Nómina" icon="pi pi-building" className="p-button mr-2 p-button-sm " onClick={() => liquidar()} />
        <Button label="Head count" icon="pi pi-book" className="p-button mr-2 p-button-sm " tooltip='Generar reporte head count'
          tooltipOptions={{ position: 'top' }} onClick={showModalHC} />
        <SelectButton value={tipo}
          onChange={(e) => {
            setTipo(e.value ? e.value : tipo);
            localStorage.setItem('vista', e.value ? e.value : tipo)
          }}
          itemTemplate={template} optionLabel="value" options={options} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => editPerson(rowData)} />
  }

  const photoBodyTemplate = (rowData) => {
    const photo = rowData.IMAGE;
    return (
      <React.Fragment>
        <img alt={""} src={photo} width={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
      </React.Fragment>
    );
  }

  const iniDateTemplate = (rowData) => {
    const date = timeToDate(rowData.START_DATE);
    return date
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  const retDateTemplate = (rowData) => {
    const date = timeToDate(rowData.RETIREMENT_DATE);
    return date
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  const footerSalarios = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading2(false); setLoading3(false); hideModalS() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading2} onClick={() => { setLoading2(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importSalaries}>
      </FileUpload>
    </div>
  );

  const headerSalarios = (
    <div>
      <h3>Cargar salarios</h3>
    </div>
  )

  const footerEmpleados = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading4(false); setLoading5(false); hideModalE() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading4} onClick={() => { setLoading4(true); downloadSampleFileEmployees() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado2} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importContracts}>
      </FileUpload>
    </div>
  );

  const headerEmpleados = (
    <div>
      <h3>Cargar empleados</h3>
    </div>
  )

  // Return que entrega la pantalla
  return (
    <div className='mt-2'>

      <Dialog header={headerHC} footer={footerHC} visible={isOpenHC} bo
        position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHC}>
        <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
        {headCountParams.map((d, index) => {
          /*Genera dinámica de los campos de entrada para el reporte head count*/
          if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && headCount.length > 0 && typeof headCount[index] !== "undefined") {
            let label = d.LABEL;
            if (d.REQUIRED === "1") {
              label = label + "*"
            }
            switch (d.TYPE) {
              case "LIST":
                let options = []
                if (d.REQUIRED === "1") {
                  options = [...d.OPTIONS]
                }
                else {
                  options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                }
                return (<>
                  <LabelField htmlFor="label">{label}</LabelField>
                  <Dropdown
                    key={index}
                    style={elementWidth}
                    value={headCount[index]["NAME"]}
                    options={options}
                    filter showClear filterBy="NAME"
                    optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                    //optionTemplate={optionTemplate}
                    placeholder={headCount[index]["NAME"] ? headCount[index]["NAME"] : "Seleccione"}
                    onChange={(e) => handleChangeHC(e, d, index)}
                  />
                </>
                );
              case "DATE":
                return (<>
                  <LabelField htmlFor="label">{label}</LabelField>
                  <Calendar key={d} style={elementWidth} id="navigators" value={headCount[index]}
                    onChange={(e) => handleChangeDateHC(e, d, index)}
                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Seleccione"
                    yearRange="2010:2030" /></>
                );
              default:
                return (<>
                  <LabelField htmlFor="label">{label}</LabelField>
                  <InputText
                    key={d}
                    style={elementWidth}
                    id="label2"
                    type="text"
                    value={headCount[index]}
                    onChange={(e) => handleChangeTextHC(e, d, index)}
                  /></>
                )
            }
          }
        })}
      </Dialog>
      <Dialog header={headerSalarios} footer={footerSalarios} visible={isOpenS}
        position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalS}>
        <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
        <br />
        <span>2. Diligencie la hoja Modelo de Cargue con la información salarial de sus empleados.</span>
        <br />
        <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
      </Dialog>
      <Dialog header={headerEmpleados} footer={footerEmpleados} visible={isOpenE}
        position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalE}>
        <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
        <br />
        <span>2. Diligencie la hoja Modelo de Cargue con la información personal y laboral de sus empleados.</span>
        <br />
        <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
      </Dialog>

      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} style={{ zIndex: 1001 }} />

        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Empleados</span>
          <Video header="Instructivo creación empleado" url={localStorage.getItem('EMPLOYES_VIDEO')} />
        </div>



        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} ></Toolbar>
            {tipo === 'tarjeta' ?
              <DataView value={products} itemTemplate={itemTemplate} layout={'grid'} paginator rows={6} />
              :
              <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="CONTRACT_ID"
                size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'JOB', 'CONTRACT_TYPE', 'STATUS', 'START_DATE', 'END_DATE', 'RETIREMENT_DATE']}
                header={header1} >
                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                <Column field="IMAGE" header="Foto" body={photoBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} sortable></Column>
                <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
                <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                <Column field="JOB" header="Cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
                <Column field="CONTRACT_TYPE" header="Tipo de contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
                <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                <Column field="START_DATE" body={iniDateTemplate} header="Fecha ingreso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha ingreso" sortable></Column>
                <Column field="END_DATE" body={endDateTemplate} header="Fecha fin contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin contrato" sortable></Column>
                <Column field="RETIREMENT_DATE" body={retDateTemplate} header="Fecha retiro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                <Column field="CAUSE_RETIREMENT" header="Motivo retiro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
                <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
              </DataTable>}
          </SkeletonTable>
        </div>
      </div>

    </div>
  );
} 